import type { SVGProps } from 'react';
const SvgUsers = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <path
      d="M9.424 10.438A3.53 3.53 0 0 1 14.73 8.96M10.612 13A4.748 4.748 0 0 0 1.2 13m9.412-7.353a2.058 2.058 0 1 0 4.116 0 2.058 2.058 0 0 0-4.116 0m-7.353 0a2.647 2.647 0 1 0 5.294 0 2.647 2.647 0 0 0-5.294 0"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
    />
  </svg>
);
export default SvgUsers;
